import { HttpTypes } from "@medusajs/types"
import { CategoryNavbar } from "@/components/molecules"

// مربّع البحث حُذف: شريط الفلاتر في الرئيسية وصفحة الكتالوج يغني عنه،
// ووجوده يعطي الزبون بابين للشيء نفسه.
export const Navbar = ({
  categories,
  parentCategories,
}: {
  categories: HttpTypes.StoreProductCategory[]
  parentCategories: HttpTypes.StoreProductCategory[]
}) => {
  // بعد إزالة «كل القطع» لا يبقى في الشريط إلا الأقسام؛ إن لم توجد فلا شريط فارغ.
  if (!categories?.length) return null
  return (
    <div className="hidden lg:flex border py-4 justify-between px-4 md:px-5" data-testid="navbar">
      <div className="flex items-center justify-between w-full">
        <CategoryNavbar
          categories={categories}
          parentCategories={parentCategories}
        />
      </div>
    </div>
  )
}
